/*
 * Woolman Common JS
 */

// Initialize window.Woolman object
if (typeof window.Woolman == 'undefined') {
  window.Woolman = {};
}
Woolman.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

// -------
// Load components / libraries
Woolman.init = function () {
  Woolman.ModalsAndDrawers.init();
  Woolman.Header.init();
  /*
  if (window.Shopify && window.Shopify.designMode) {
    Woolman.ThemeEditorIntegration.init();
  }
  */
};

Woolman.config = {
  youTubeLoaded: false,
  vimeoLoaded: false,
};

// -------
// Woolman Common JS - Utility library
Woolman.Utils = {
  debugMode: true,
  focusTraps: {},
  checkCanFocusTrap: (trapContainers) => {
    const results = trapContainers.map((trapContainer) => {
      return new Promise((resolve) => {
        const interval = setInterval(() => {
          if (getComputedStyle(trapContainer).visibility !== 'hidden') {
            resolve();
            clearInterval(interval);
          }
        }, 5);
      });
    });
    // Return a promise that resolves when all the trap containers are able to receive focus
    return Promise.all(results);
  },
  onFocusTrapDeactivate: (targetElement) => {
    targetElement.classList.remove('focus-trap');
    document.body.classList.remove('focus-being-trapped');
  },
  onFocusTrapActivate: (targetElement) => {
    targetElement.classList.add('focus-trap');
    document.body.classList.add('focus-being-trapped');
  },
  clearFocusTrap: (cacheKey) => {
    if (Woolman.Utils.focusTraps[cacheKey]) {
      Woolman.Utils.focusTraps[cacheKey].deactivate();
      Woolman.Utils.focusTraps[cacheKey] = undefined;
    }
  },
  prepareQueryParams: () => {
    Shopify.queryParams = Shopify.queryParams || {};

    // Preserve existing query parameters
    if (location.search.length) {
      const params = location.search.substr(1).split('&');

      for (let i = 0; i < params.length; i++) {
        const keyValue = params[i].split('=');

        if (keyValue.length) {
          Shopify.queryParams[decodeURIComponent(keyValue[0])] = decodeURIComponent(keyValue[1]);
        }
      }
    }

    return Shopify.queryParams;
  },
  formatMoney(cents, format) {
    var default_money_format = '€{{amount}}';
    if (typeof cents == 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || default_money_format;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  },
};

// -------
// Woolman Common JS - Header component
Woolman.Header = {
  selectors: {
    header: 'header.header',
    search: '[data-header-search]',
    searchOpen: `a[href="${routes.search_url}"]`,
    searchClose: '.header-search__close',
    cartBlip: '.cart-blip',
  },
  cache: {
    header: undefined,
    search: undefined,
    searchOpen: undefined,
    searchClose: undefined,
    cartBlip: undefined,
  },
  focusTraps: {},
  init: function () {
    this.cache.header = document.querySelector(this.selectors.header);
    this.cache.search = this.cache.header.querySelector(this.selectors.search);
    this.cache.searchOpen = this.cache.header.querySelectorAll(this.selectors.searchOpen);
    this.cache.searchClose = this.cache.header.querySelector(this.selectors.searchClose);
    this.cache.cartBlip = this.cache.header.querySelector(this.selectors.cartBlip);

    this.cache.searchOpen.forEach((button) => {
      button.addEventListener('click', this.onSearchOpen.bind(this));
    });
    this.cache.searchClose.addEventListener('click', this.onSearchClose.bind(this));

    // Update cart blip when product is added to cart.
    document.addEventListener('ajaxProduct:added', this.updateCartBlip.bind(this));
    document.addEventListener('cart:update', this.updateCartBlip.bind(this));

    if (this.cache.header.dataset.stickyBehavior === 'none') return;
    this.initStickyBehavior(this.cache.header.dataset.stickyBehavior);
  },
  onSearchOpen(event) {
    event.preventDefault();

    const targetElement = this.cache.search;
    Woolman.Utils.focusTraps['search'] = focusTrap.createFocusTrap(targetElement, {
      escapeDeactivates: true,
      checkCanFocusTrap: Woolman.Utils.checkCanFocusTrap,
      onActivate: () => {
        targetElement.classList.add('is-open');
        Woolman.Utils.onFocusTrapActivate(targetElement);
        bodyScrollLock.disableBodyScroll(targetElement);
        setTimeout(() => {
          targetElement.classList.add('animation');
        });
      },
      onDeactivate: () => {
        targetElement.classList.remove('animation');
        bodyScrollLock.enableBodyScroll(targetElement);
        Woolman.Utils.onFocusTrapDeactivate(targetElement);
        setTimeout(() => {
          targetElement.classList.remove('is-open');
        });
      },
    });

    Woolman.Utils.focusTraps['search'].activate();
  },
  onSearchClose(event) {
    event.preventDefault();
    Woolman.Utils.clearFocusTrap('search');
  },
  initStickyBehavior(behaviorType) {
    const stickyConfig = {
      headerHeight: this.cache.header.clientHeight,
      offsetThreshold: this.cache.header.offsetTop,
      behavior: behaviorType,
    };

    document.documentElement.classList.add('sticky-header-initialized');
    document.documentElement.style.setProperty('--sticky-header-margin-top', `${stickyConfig.headerHeight}px`);

    if (behaviorType == 'scroll') {
      // Show on scroll fixed header
      let prevScroll = window.scrollY || document.documentElement.scrollTop;
      let curScroll;
      let direction = 0;
      let prevDirection = 0;

      /*
       ** Find the direction of scroll
       ** 0 - initial, 1 - up, 2 - down
       */

      const toggleStickyHeader = (direction, curScroll) => {
        if (direction === 1 || curScroll < stickyConfig.headerHeight) {
          document.documentElement.classList.remove('sticky-header-hide');
        } else if (direction === 2 && curScroll > stickyConfig.headerHeight) {
          document.documentElement.classList.add('sticky-header-hide');
        }

        prevDirection = direction;
      };

      window.addEventListener(
        'scroll',
        throttle(() => {
          curScroll = window.scrollY || document.documentElement.scrollTop;

          if (curScroll >= 100) {
            document.documentElement.classList.add('sticky-header-show');
          } else {
            document.documentElement.classList.remove('sticky-header-show');
          }

          if (curScroll > prevScroll) {
            direction = 2; // user scrolling down
          } else {
            direction = 1; // user scrolling up
          }

          if (direction !== prevDirection) {
            toggleStickyHeader(direction, curScroll);
          }

          prevScroll = curScroll;
        }, 100)
      );
    }
  },
  async updateCartBlip(e) {
    const cart =
      (e.detail && e.detail.cart && e.detail.cart.item_count) ||
      (await (async function () {
        const res = await fetch('/cart.json');
        const cart = await res.json();
        return cart;
      })());

    this.cache.cartBlip.textContent = cart.item_count || 0;
    if (cart && cart.item_count == 0) {
      this.cache.cartBlip.setAttribute('hidden', true);
    } else {
      this.cache.cartBlip.removeAttribute('hidden');
    }
  },
};

// -------
// Woolman Common JS - Modals & drawers library
Woolman.ModalsAndDrawers = {
  settings: {
    selectors: {
      modalLink: 'a[href*="modal"]',
      drawerLink: 'a[href*="drawer"]',
    },
  },
  focusTraps: {},
  init: function () {
    document.querySelectorAll(this.settings.selectors.modalLink).forEach((modalLink) => {
      modalLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1);
        this.showModalOrDrawer(targetId);
      });
    });

    document.querySelectorAll(this.settings.selectors.drawerLink).forEach((drawerLink) => {
      drawerLink.addEventListener('click', (event) => {
        event.preventDefault();
        const targetId = event.currentTarget.getAttribute('href').substring(1);
        this.showModalOrDrawer(targetId);
      });
    });
  },
  /**
   *
   * @param {string} targetId - ID of modal or drawer element, e.g. modal-geo, drawer-menu
   * Traps focus to modal and disables body scrolling.
   * Focus trap utilizes focus-trap library: https://github.com/focus-trap/focus-trap
   */
  showModalOrDrawer: function (targetId) {
    const targetElement = document.getElementById(targetId);
    if (!targetElement && Woolman.Utils.debugMode) {
      console.warn('No modal/drawer element specified');
    }
    if (!targetElement) {
      return;
    }

    targetElement.classList.add('initialized', 'is-open');

    if (!Woolman.Utils.focusTraps[targetId]) {
      const trapTarget = targetElement.querySelector('[data-contents') || targetElement;
      Woolman.Utils.focusTraps[targetId] = focusTrap.createFocusTrap(trapTarget, {
        clickOutsideDeactivates: true,
        escapeDeactivates: true,

        // Called before focus is sent
        onActivate: () => {
          Woolman.Utils.onFocusTrapActivate(targetElement);

          const closeBtns = targetElement.querySelectorAll('[data-close]');
          if (closeBtns) {
            closeBtns.forEach((closeBtn) => {
              closeBtn.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
            });
          }

          const overlay = targetElement.querySelector('[data-overlay]');
          if (overlay) {
            overlay.addEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
          }

          bodyScrollLock.disableBodyScroll(targetElement);
          document.documentElement.classList.add('sticky-header-hide', 'buy-banner-hide');
        },

        // There is a delay between when the class is applied
        // and when the element is focusable
        checkCanFocusTrap: Woolman.Utils.checkCanFocusTrap,

        // Called after focus is deactivated
        onDeactivate: () => {
          targetElement.querySelectorAll('[data-close]').forEach((closeBtn) => {
            closeBtn.removeEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
          });

          const overlay = targetElement.querySelector('[data-overlay]');
          if (overlay) {
            overlay.click();
            overlay.removeEventListener('click', this.closeModalOrDrawerOrDrawerFromEvent.bind(this));
          }
          bodyScrollLock.enableBodyScroll(targetElement);
          Woolman.Utils.onFocusTrapDeactivate(targetElement);
          document.documentElement.classList.remove('sticky-header-hide', 'buy-banner-hide');
        },
      });
    }

    Woolman.Utils.focusTraps[targetId].activate();
  },
  /**
   *
   * @param {string} targetId - ID of target element, e.g. modal-geo, drawer-menu
   * Removes trapped focus when modal is closed by e.g. using the close button.
   */
  closeModalOrDrawer: function (targetId) {
    if (Woolman.Utils.focusTraps[targetId]) {
      Woolman.Utils.focusTraps[targetId].deactivate();
      Woolman.Utils.focusTraps[targetId] = undefined;
    }
  },
  closeModalOrDrawerOrDrawerFromEvent: function (event) {
    event.preventDefault();
    const parentElement = event.currentTarget.closest('[data-parent]');
    const targetId = parentElement.getAttribute('id');
    parentElement.classList.remove('is-open');
    this.closeModalOrDrawer(targetId);
  },
};

// is it needed?
/*
Woolman.ThemeEditorIntegration = {
  init: function() {
    document.addEventListener("shopify:section:select", this.onEditorSelectionUpdated)
    document.addEventListener("shopify:section:deselect", this.onEditorSelectionUpdated)

  },
  onEditorSelectionUpdated: function(event) {
    console.log('event', event)
    const { sectionId, load } = event.detail;
    const elementToHighlight = document.getElementById(`shopify-section-${sectionId}`);

    if (!elementToHighlight) return;
    if (event.type == 'shopify:section:select') {
      elementToHighlight.classList.add('theme-editor-focus')
    } else {
      elementToHighlight.classList.remove('theme-editor-focus')
    }
  }
}
*/

Woolman.init();

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, wait) {
  let t = false;
  return (...args) => {
    if (!t) {
      fn.apply(this, args);
      t = true;
      setTimeout(() => (t = false), wait);
    }
  };
}

/**
 * Allow us to trigger something when window is actually resized.
 */
let woolman_window_size = window.innerWidth;
window.addEventListener(
  'resize',
  debounce(() => {
    if (window.innerWidth == woolman_window_size) {
      return;
    }
    woolman_window_size = window.innerWidth;
    document.dispatchEvent(new CustomEvent('woolman:resize'));
  }),
  250
);

window.processingSplider = false;
class SpliderParent extends HTMLElement {
  constructor() {
    'use strict';
    super();

    const styles = getComputedStyle(this);
    const perPage = parseInt(styles.getPropertyValue('--items-per-row-desktop')) || 3;
    const perMoveTablet = parseInt(styles.getPropertyValue('--items-per-row-tablet')) || 2;
    const perPageMobile = parseInt(styles.getPropertyValue('--items-per-row-mobile')) || 1;
    const perMoveDesktop = parseInt(styles.getPropertyValue('--items-per-row-desktop')) || 3;
    const gap = styles.getPropertyValue('--gap') || getComputedStyle(document.documentElement).getPropertyValue('--grid-gap-product');

    if (this.hasAttribute('data-is-suggestor')) {
      this.config = this.dataset.splide
        ? JSON.parse(this.dataset.splide)
        : {
            perPage: perPage,
            drag: 'free',
            gap: gap,
            snap: true,
            autoWidth: true,
            lazyLoad: 'nearby',
            pagination: false,
            arrows: true,
            breakpoints: {
              768: {
                perPage: perPageMobile,
              },
            },
          };
    } else if (!this.hasAttribute('data-has-thumbnail')) {
      this.config = this.dataset.splide
        ? JSON.parse(this.dataset.splide)
        : {
            keyboard: true,
            perPage: perPage,
            perMove: perMoveDesktop,
            drag: 'free',
            gap: gap,
            snap: true,
            autoWidth: true,
            lazyLoad: 'nearby',
            pagination: false,
            arrows: true,
            breakpoints: {
              1024: {
                perMove: perMoveTablet,
              },
              678: {
                perPage: perPageMobile,
                perMove: perPageMobile,
                arrows: true,
                breakpoints: {
                  768: {
                    perPage: perPageMobile,
                    arrows: true,
                  },
                },
              },
            },
          };
    } else {
      this.config = {
        pagination: false,
        arrows: true,
        cover: true,
      };

      this.thumbConfig = {
        rewind: true,
        isNavigation: true,
        arrows: false,
        gap: gap,
        focus: 'center',
        pagination: false,
        cover: true,
        autoWidth: true,
        dragMinThreshold: {
          mouse: 4,
          touch: 10,
        },
      };
    }

    this.el = this;
    this.splide = undefined;
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.downloadAndMount();
      }
    });

    this.checkIfCanMount();
    document.addEventListener('woolman:resize', () => {
      this.checkIfCanMount();
    });

    document.addEventListener('updateSlider', (evt) => {
      this.updateSlider(evt.detail.list, evt.detail.id, evt.detail.styling);
    });

    this.setupListeners();
  }

  setupListeners() {
    document.addEventListener(
      'shopify:block:select',
      function (event) {
        const blockSelectedIsSlide = event.target.classList.contains('splide__slide');
        const currentSliderId = event.target.closest('slider-component').dataset.id;

        if (!blockSelectedIsSlide || !this.splide || this.dataset.id != currentSliderId) return;

        const index = parseInt(event.target.dataset.index);
        this.splide.go(index);

        const autoplay = this.splide.Components.Autoplay;
        autoplay.pause();
      }.bind(this)
    );

    document.addEventListener(
      'shopify:block:deselect',
      function (event) {
        const blockSelectedIsSlide = event.target.classList.contains('splide__slide');
        const currentSliderId = event.target.closest('slider-component').dataset.id;

        if (!blockSelectedIsSlide || !this.splide || this.dataset.id != currentSliderId) return;

        const autoplay = this.splide.Components.Autoplay;
        autoplay.play();
      }.bind(this)
    );
  }

  checkIfCanMount() {
    const mobileOnly = this.hasAttribute('data-mobile-only');
    const desktopOnly = this.hasAttribute('data-desktop-only');
    const breakpoint = 1024;

    if (!mobileOnly && !desktopOnly) {
      if (!this.splide) {
        this.allowMounting();
      }else{
        this.splide.refresh();
      }
      return;
    }

    if (mobileOnly && woolman_window_size < breakpoint) {
      if (!this.splide) {
        this.allowMounting();
      }else{
        this.splide.refresh();
      }
      return;
    }
    if (desktopOnly && woolman_window_size >= breakpoint) {
      if (!this.splide) {
        this.allowMounting();
      }else{
        this.splide.refresh();
      }
      return;
    }

    this.disallowMounting();
  }

  allowMounting(skipClassGeneration = false) {
    if (!skipClassGeneration) {
      this.classList.add('splide');
      this.querySelectorAll('[data-class]').forEach((elem) => {
        elem.classList.add(elem.dataset.class.split(' '));
      });
    }

    if (!this.hasAttribute('data-skip-observe')) {
      this.observer.observe(this.el);
    } else {
      this.downloadAndMount();
    }
  }

  disallowMounting() {
    if (this.splide) {
      this.splide.destroy(true);
      this.el.classList.remove('is-initialized');
    }

    this.classList.remove('splide');
    this.querySelectorAll('[data-class]').forEach((elem) => {
      elem.classList.remove(elem.dataset.class.split(' '));
    });

    this.splide = undefined
    this.observer.unobserve(this.el);
  }

  downloadAndMount() {
    const sliderAssetUrl = theme.assets.slider;
    const existingScript = document.querySelector(`script[src="${sliderAssetUrl}"]`);

    if (window.processingSplider) {
      setTimeout(this.downloadAndMount.bind(this), 200);
      return;
    }

    if (existingScript) {
      this.mountSlider();
      return;
    }

    window.processingSplider = true;
    const script = document.createElement('script');
    script.setAttribute('defer', 'true');
    script.setAttribute('async', 'true');
    script.src = sliderAssetUrl;
    document.body.append(script);

    script.addEventListener('load', () => {
      this.mountSlider();
    });
  }

  updateSlider(list, id, styling) {
    if (this.splide && this.splide.root.id == id) {
      this.splide.remove((Slide) => Slide);
      this.splide.add(list);
      // this is for suggest section
      if (styling) {
        this.style.setProperty('--items-per-row-desktop', styling);
        this.style.setProperty('--items-per-row-mobile', styling);
      }
    }
  }

  mountSlider() {
    this.splide = new Splide(this.el, this.config);

    if (this.thumbConfig) {
      const thumbEl = document.getElementById(this.getAttribute('data-has-thumbnail'));
      this.thumbSplide = new Splide(thumbEl, this.thumbConfig);
      this.splide.sync(this.thumbSplide);
    }

    this.splide.mount();

    if (this.thumbSplide) {
      this.thumbSplide.mount();
    }

    this.observer.unobserve(this.el);
    this.dispatchEvent(new CustomEvent('mounted', { detail: { splide: this.splide } }));

    window.processingSplider = false;
  }
}

if (customElements.get('slider-component') === undefined) {
  customElements.define('slider-component', SpliderParent);
}

class CustomSelect extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      select: this.querySelector('#select'),
      dropdownBox: this.querySelector('#optionList'),
      results: document.getElementById(this.getAttribute('data-results')),
    };

    const dropdownBoxChilds = Array.from(this.elements.dropdownBox.children);
    dropdownBoxChilds.forEach((elem) => {
      elem.addEventListener('click', this.optionsSelect.bind(this));
      elem.addEventListener('keydown', this.optionsSelect.bind(this));
      elem.addEventListener('focusout', this.optionsfocusout.bind(this));
    });

    this.elements.select.addEventListener('click', this.toggleDropdown.bind(this));
    this.elements.select.addEventListener('keydown', this.toggleDropdown.bind(this));
    this.elements.select.addEventListener('focusout', this.closeDropdown.bind(this));
  }

  scrollableDropdown(element, op) {
    const elementChilds = Array.from(element.children);
    elementChilds.forEach((elem) => {
      if (elem.hasAttribute('tabindex') || op == 'close') {
        elem.removeAttribute('tabindex');
      } else {
        elem.setAttribute('tabindex', 0);
      }
    });
  }

  optionsSelect(event) {
    if (event.key != null && event.key != 'Enter') return;
    const customOption = event.target;
    this.elements.select.value = customOption.getAttribute('data-value');
    this.elements.select.onchange();
    customOption.blur();
  }

  optionsfocusout(event) {
    const customOption = event.target;
    setTimeout(() => {
      if (!this.elements.dropdownBox.contains(document.activeElement)) {
        this.classList.remove('open');
        this.scrollableDropdown(this.elements.dropdownBox, 'close');
        customOption.blur();
      }
    }, 150);
  }

  toggleDropdown(event) {
    if (event.key != null && event.key != 'Enter') return;
    const customSelect = event.target;
    this.classList.toggle('open');
    this.scrollableDropdown(this.elements.dropdownBox);
    if (!this.classList.value.includes('open')) {
      customSelect.blur();
    }
  }

  closeDropdown(event) {
    const customSelect = event.target;
    setTimeout(() => {
      if (!this.elements.dropdownBox.contains(document.activeElement)) {
        this.scrollableDropdown(this.elements.dropdownBox, 'close');
        this.classList.remove('open');
        customSelect.blur();
      }
    }, 150);
  }
}

customElements.define('custom-select', CustomSelect);

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list-wrapper'),
    };
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);


class SuperPoweredVideo extends HTMLElement {
  constructor() {
    super();

    this.video = this.querySelector('video') || this.querySelector('iframe');
    if (this.closest('.video-container')) this.attachClickListener(this.closest('.video-container'));
  }

  attachClickListener(videoContainer) {
    if (!videoContainer) return;
    videoContainer.addEventListener('click', (e) => {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    });

    this.video.onplay = () => {
      videoContainer.querySelector('button').hidden = true;
    }

    this.video.onpause = () => {
      videoContainer.querySelector('button').hidden = false;
    }
  }
}

customElements.define('superpowered-video', SuperPoweredVideo);
// Function that adds 'in-viewport' class to any .shopify-section when it enters the viewport
// Uses IntersectionObserver API for the detection
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
(function addInViewportClass(elements) {
  const threshold = Shopify || Shopify.designMode === true ? 0 : 0.15;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('section-in-view');
        entry.target.dispatchEvent(new CustomEvent('section:in-viewport'))
        observer.unobserve(entry.target);
      }
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: [threshold, 1],
  });

  elements.forEach((el) => {
    observer.observe(el);
  });
})(document.querySelectorAll('.shopify-section'))
